import { NewExternalSystem } from '@cbgms/api/modules/shops/external-systems'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useNotifier } from '@cbgms/base/notifier'
import { useParams } from 'react-router-dom'
import navigation from 'utils-support/navigation'
import ExternalSystemForm from './ExternalSystemForm'
import { createExternalSystem } from './state/actions'

const NewExternalSystemForm = () => {
  const dispatch = useDispatch()
  const { companyUUID, shopID } = useParams<{ companyUUID: string; shopID: string }>()
  const { t } = useTranslation()
  const notifier = useNotifier()

  const onSubmit = (values: NewExternalSystem) => {
    dispatch(createExternalSystem(companyUUID, shopID, values))
  }

  const onSubmitSuccess = () => {
    notifier.success(t('external-systems.create-success'))
    navigation.goBack()
  }

  return (
    <ExternalSystemForm
      form='new-external-system'
      onSubmitSuccess={onSubmitSuccess}
      onSubmit={onSubmit}
      redirectToURL={`/companies/${companyUUID}/shops/edit/${shopID}#externalsystems`}
    />
  )
}

export default NewExternalSystemForm
